import { API } from '@weave/schema-gen-ts/dist/schemas/ai-settings/v1/service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaV1Service = bindHTTP(API);
export const serviceName = 'v1' as const;
